<div class="head-wrapper">
    <h2 class="">Current Dataset's List</h2>
    <a class="link" pTooltip="Refresh List" tooltipPosition="top" (click)="getDataSetById(accountId)">
        <i class="pi pi-refresh"></i>
    </a>
</div>

<div class="datasetWrapper">
    <ng-container *ngIf="dataSetList.length">
        <div *ngFor="let item of dataSetList" >
            <a (click)="datasetIdtoParent(item.id)" class="link linkDataSet">{{item.datasetName}} - (Dataset ID: {{item.id}})</a>
            <span class="dataSetStatus {{item.status}}">{{item.status}}</span>
        </div>
    </ng-container>
    <div class="noData" *ngIf="!dataSetList.length">
        <ng-container>DataSet Not Available</ng-container> 
    </div>
</div>
<br />
<br />

<h2 class="">Select Dataset file for Process</h2>
<div class="action-wrapper">
    <form [formGroup]="dataSetForm" #form="ngForm" (ngSubmit)="validate()">
        <div class="form-group">
            <label for="datasetFile" class="col-sm-4 col-form-label">Uploded Dataset Files <span
                    class="required">*</span></label>
            <div class="control-wrapper">
                <select class="form-control" id="datasetFile" formControlName="datasetFile"
                    [class.is-invalid]="dataSetForm.controls['datasetFile'].invalid && (dataSetForm.controls['datasetFile'].dirty || dataSetForm.controls['datasetFile'].touched)">
                    <option value="">Select file</option>
                    <ng-container *ngFor="let obj of dataSetFileList">
                        <option *ngIf="obj.status !== 'Processed'" [ngValue]="obj.fileName">{{obj.fileName}}</option>
                    </ng-container>
                </select>
                <div *ngIf="dataSetForm.controls['datasetFile'].invalid && (dataSetForm.controls['datasetFile'].dirty || dataSetForm.controls['datasetFile'].touched)"
                    class="invalid-feedback">
                    <div *ngIf="dataSetForm.controls['datasetFile'].errors?.['required']">
                        This field is required.
                    </div>
                </div>
            </div>
        </div>
        <button type="submit" class="button newDataSet">Submit</button>
    </form>
</div>